// extracted by mini-css-extract-plugin
module.exports = {"listContainer":"src-components-Invitations-styles-module__listContainer--3USnD"};